<div class="container-fluid">
  <h5 class="my-4">{{ company.name }}</h5>

  <div class="jumbotron-fluid">
    <div class="row" *ngIf="company">
      <!-- First Column -->
      <div class="col-md-4">
        <mat-form-field>
          <input
            type="text"
            matInput
            placeholder="Company Name"
            [(ngModel)]="company.name"
            required
            (change)="update()"
          />
        </mat-form-field>

      </div>


      <!-- Second Column -->
      <div class="col-md-4">
        <mat-form-field>
          <input type="text" matInput placeholder="Address 1" [(ngModel)]="company.address1" (change)="update()"/>
        </mat-form-field>

      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input type="text" matInput placeholder="Address 2" [(ngModel)]="company.address2" (change)="update()"/>
        </mat-form-field>
      </div>

      <div class="col-md-3">

        <mat-form-field>
          <input type="text" matInput placeholder="City" [(ngModel)]="company.city" (change)="update()"/>
        </mat-form-field>

      </div>

      <div class="col-md-3">
        <mat-form-field>
          <input type="text" matInput placeholder="Postal Code" [(ngModel)]="company.postal_code" (change)="update()"/>
        </mat-form-field>
      </div>
      <!-- Third Column -->
      <div class="col-md-3">
        <mat-form-field>
          <input type="text" matInput placeholder="State" [(ngModel)]="company.region" (change)="update()"/>
        </mat-form-field>

      </div>
      <div class="col-md-3">
        <mat-form-field>
          <input type="text" matInput placeholder="Country" [(ngModel)]="company.country" (change)="update()"/>
        </mat-form-field>
      </div>
    </div>
  </div>

  <h5 class="my-4">Primary Contacts</h5>
  <dx-data-grid
    id="gridContainer"
    class="no-borders"
    [dataSource]="clientCompanies"
    [hoverStateEnabled]="true"
    keyExpr="id"
    [selectedRowKeys]="[]">
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-selection mode="single"></dxo-selection>
    <dxi-column dataField="organization_name" caption="Company Name"></dxi-column>
    <dxi-column [calculateCellValue]="getContactFullName" caption="Primary Contact"></dxi-column>
    <dxi-column dataField="primary_contact.email" caption="Primary Contact Email"></dxi-column>
    <dxi-column dataField="primary_contact.phone_number" caption="Primary Contact Phone Number"></dxi-column>
    <dxi-column dataField="client_type" caption="Relation"></dxi-column>
    <dxi-column dataField="created_at" caption="Clients Since" format="shortDate" dataType="date">
    </dxi-column>
  </dx-data-grid>
</div>


<div class="col-12">
  <financial-report-type></financial-report-type>
</div>